const ScrollManager = () => {

  const articles = document.querySelectorAll('article');

  const init = () => {
    window.addEventListener('scroll', handleScroll)
    handleScroll();
  }

  const handleScroll = () => {
    articles.forEach(el => {
      if (isInView(el)) {
        el.classList.add('active');
      } else {
        el.classList.remove('active')
      }
    })

  }

  const isInView = (el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  init()
}